import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const InstallationTypeFormatter = ({ typeApplication }) => {
    const { t } = useTranslation();

    if (!typeApplication)
        return (
            <Typography variant="caption">
                {t('No installation type')}
            </Typography>
        );

    return <Typography variant="caption">{typeApplication}</Typography>;
};

InstallationTypeFormatter.propTypes = { typeApplication: PropTypes.string };

export default InstallationTypeFormatter;
